module.exports = __webpack_public_path__ + "img/2.b9cdc420.jpg";